import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@material-ui/core";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import moment from "moment";
import { ResponsiveContainer } from "recharts";
import useStyles from "./style";
import TopInfoBox from "./topInfoBox";
import { httpClient } from "appUtility/Api";
import { handlePhoneNumberValidation } from "../../../appUtility/phoneNumberUtils";
import { NotificationManager } from "react-notifications";
import ThankYouReference from "../../../components/ThankYou";
import EndCallCard from "../../../components/EndCallCard";
import SuspendedFranchiseeInfo from "../../../components/SuspendedFranchiseeInfo";

const qs = require("qs");

function ContinueCancelBooking(props) {
  const classes = useStyles();
  const [stage, setStage] = useState(0);
  const [isFocused, setIsFocused] = useState(false);

  const { suburbList } = props;

  const inputRef = useRef([]);

  let loginData = JSON.parse(localStorage.getItem("login"));

  useEffect(() => {
    if (props.callerPressed.firstName || props.callerPressed.lastName) {
      setStage(0);
    } else if (
      props.callerPressed.phoneNumber1 ||
      props.callerPressed.phoneNumber2
    ) {
      setStage(1);
    } else if (props.callerPressed.postCode) {
      setStage(2);
    } else if (props.callerPressed.address) {
      setStage(3);
    } else if (props.callerPressed.message) {
      setStage(4);
    }
  }, [props]);

  const handleFocus = () => setIsFocused(true);
  const handleBlur = () => setIsFocused(false);

  const handlePostCodePress = (e) => {
    if (e.key === "Enter") {
      var postQuery = {
        userID: loginData && loginData.uid,
        userCode: loginData && loginData.aCode,
        appID: 1,
        postCode: props.postCode,
      };
      httpClient
        .post(
          "getSuburbs_Franchise.php",
          qs.stringify({
            action: "get_suburbs",
            source: postQuery,
          })
        )
        .then((res) => {
          if (res.data.error) {
            props.setPostCodeValid(false);
            props.setSuburb([]);
            props.setSuburb("");
          } else {
            if (res.data[0] === "No Valid Suburb found on system") {
              NotificationManager.warning("No valid postcode found on system");
              props.setSuburbList([]);
              props.setSuburb("");
              props.setPostCodeValid(false);
            } else {
              props.setSuburbList(res.data);
              props.setPostCodeValid(true);

              // Pick the first suburb that has any members,
              // otherwise default to the very first suburb in the list
              const firstSuburbWithMembers = res.data.find(
                (suburb) => suburb.memberNames !== null
              );

              const targetSuburb =
                firstSuburbWithMembers !== undefined
                  ? firstSuburbWithMembers
                  : res.data[0];

              if (targetSuburb) {
                props.setSuburb(targetSuburb);
              }
            }
          }
        });
    }
  };

  const handleChangeSuburb = (e) => {
    const selectedSuburbId = e.target.value;

    // Find the full suburb object from the list based on the selected ID
    const selectedSuburbObject = suburbList.find(
      (sub) => sub.suburbID == selectedSuburbId // Use == in case of type mismatch
    );

    // Pass the full object to the parent's setter function
    if (selectedSuburbObject) {
      props.setSuburb(selectedSuburbObject);
    } else {
      props.setSuburb("");
    }
  };

  const handleSubmit = () => {
    if (!props.callerDetails.firstName) {
      NotificationManager.warning("First Name is required");
      return;
    }

    if (!props.callerDetails.phoneNumber1) {
      NotificationManager.warning("Phone Number 1 is required");
      return;
    }

    const isValid = handlePhoneNumberValidation(
      props.callerDetails.phoneNumber1,
      props.callerDetails.phoneNumber2
    );
    if (!isValid) {
      return;
    }

    if (!props.postCode) {
      NotificationManager.warning("Postcode is required");
      return;
    }

    if (props.postCode && !props.postCodeValid) {
      NotificationManager.warning("Postcode is not valid");
      return;
    }

    if (props.postCode && !props.suburb) {
      NotificationManager.warning("Please select suburb");
      return;
    }

    if (!props.callerDetails.address) {
      NotificationManager.warning("Address is required");
      return;
    }

    if (!props.callerDetails.message) {
      NotificationManager.warning("Message is required");
      return;
    }

    props.handleContinue();
  };

  return (
    <ResponsiveContainer>
      <div className="row">
        <div className="col-md-12">
          {props.showResetButton ? (
            <TopInfoBox text="Thank you for your call" />
          ) : props.suspendedFranchisee.leadSuspend === "0" ? (
            <>
              {stage === 0 && (
                <TopInfoBox text="May I have your name please ?" />
              )}
              {stage === 1 && (
                <TopInfoBox text="And what is the best number to contact you on ? " />
              )}
              {stage === 2 && (
                <TopInfoBox
                  text="May I have your postcode please?"
                  subText="And your suburb please ?"
                />
              )}

              {stage === 3 && (
                <TopInfoBox text="May I take your address please ?" />
              )}

              {stage === 4 && (
                <TopInfoBox text="May I take brief details of your message" />
              )}
            </>
          ) : (
            <>
              {props.suspendedFranchisee.leadSuspend === "1" && (
                <SuspendedFranchiseeInfo
                  suspendedFranchisee={props.suspendedFranchisee}
                />
              )}
            </>
          )}

          {!props.showResetButton ? (
            <div className={classes.selectBox}>
              <form>
                <div className="row">
                  {props.suspendedFranchisee.leadSuspend === "0" && (
                    <>
                      <div className="col-md-6">
                        <InputLabel className="mb-2">FirstName</InputLabel>
                        <TextField
                          variant="outlined"
                          name="firstName"
                          value={props.callerDetails.firstName}
                          onChange={props.handleChange}
                          className={classes.textField}
                          onFocus={props.handleCallerFocus}
                          helperText={
                            !props.callerDetails.firstName
                              ? "Please enter the First Name"
                              : ""
                          }
                          ref={inputRef}
                        />
                      </div>
                      <div className="col-md-6">
                        <InputLabel className="mb-2">LastName</InputLabel>
                        <TextField
                          variant="outlined"
                          name="lastName"
                          value={props.callerDetails.lastName}
                          onChange={props.handleChange}
                          className={classes.textField}
                          onFocus={props.handleCallerFocus}
                          helperText={
                            !props.callerDetails.lastName
                              ? "Please enter the Last Name"
                              : ""
                          }
                          ref={inputRef}
                        />
                      </div>
                      {(props.callerDetails.firstName ||
                        props.callerDetails.lastName) && (
                        <div className="col-md-6 mt-4">
                          <InputLabel className="mb-2">
                            Phone Number 1
                          </InputLabel>
                          <TextField
                            variant="outlined"
                            name="phoneNumber1"
                            type="text"
                            value={props.callerDetails.phoneNumber1}
                            onChange={props.handleChange}
                            className={classes.textField}
                            onFocus={props.handleCallerFocus}
                            helperText={
                              !props.callerDetails.phoneNumber1
                                ? "Please enter the Phone Number 1"
                                : ""
                            }
                            inputProps={{
                              maxLength: 10,
                              inputMode: "numeric", // Brings up numeric keypad on mobile
                              pattern: "[0-9]*", // Helps with native validation
                            }}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(
                                /\D/g,
                                ""
                              ); // Remove all non-digits
                            }}
                          />
                        </div>
                      )}
                      {(props.callerDetails.firstName ||
                        props.callerDetails.lastName) && (
                        <div className="col-md-6 mt-4">
                          <InputLabel className="mb-2">
                            Phone Number 2
                          </InputLabel>
                          <TextField
                            variant="outlined"
                            name="phoneNumber2"
                            type="text"
                            value={props.callerDetails.phoneNumber2}
                            onChange={props.handleChange}
                            className={classes.textField}
                            onFocus={props.handleCallerFocus}
                            helperText={
                              !props.callerDetails.phoneNumber2
                                ? "Please enter the Phone Number 2"
                                : ""
                            }
                            inputProps={{
                              maxLength: 10,
                              inputMode: "numeric", // Brings up numeric keypad on mobile
                              pattern: "[0-9]*", // Helps with native validation
                            }}
                            onInput={(e) => {
                              e.target.value = e.target.value.replace(
                                /\D/g,
                                ""
                              ); // Remove all non-digits
                            }}
                          />
                        </div>
                      )}
                      {(props.callerDetails.firstName ||
                        props.callerDetails.lastName) &&
                        (props.callerDetails.phoneNumber1 ||
                          props.callerDetails.phoneNumber2) && (
                          <>
                            <div className="col-md-6 mt-4">
                              <InputLabel>Post Code</InputLabel>
                              <TextField
                                variant="outlined"
                                name="postCode"
                                type="number"
                                value={props.postCode}
                                onChange={(e) => props.handlePostCode(e)}
                                onFocus={props.handleCallerFocus}
                                onKeyPress={handlePostCodePress}
                                helperText="Please Press Enter after you have inserted your Post Code"
                                margin="normal"
                                fullWidth
                              />
                            </div>
                            <div className="col-md-6 mt-4">
                              <div>
                                <InputLabel className="mb-3">Suburb</InputLabel>
                                {suburbList && suburbList.length > 0 ? (
                                  <FormControl
                                    variant="outlined"
                                    style={{ width: "100%" }}
                                  >
                                    <Select
                                      name="suburb"
                                      value={
                                        (typeof props.suburb === "object"
                                          ? props.suburb &&
                                            props.suburb.suburbID
                                          : props.suburb) || ""
                                      }
                                      onChange={handleChangeSuburb}
                                    >
                                      {suburbList &&
                                        suburbList.map((sub) =>
                                          sub.count == "0" ? (
                                            <MenuItem
                                              style={{ color: "red" }}
                                              key={sub.suburbID}
                                              value={sub.suburbID}
                                            >
                                              <span style={{ color: "red" }}>
                                                {sub.suburbName +
                                                  "," +
                                                  " " +
                                                  sub.stateShortName +
                                                  " " +
                                                  "(" +
                                                  sub.count +
                                                  ")"}
                                              </span>
                                            </MenuItem>
                                          ) : (
                                            <MenuItem
                                              style={{ color: "green" }}
                                              key={sub.suburbID}
                                              value={sub.suburbID}
                                            >
                                              <span style={{ color: "green" }}>
                                                {sub.suburbName
                                                  ? sub.suburbName +
                                                    "," +
                                                    " " +
                                                    sub.stateShortName +
                                                    " " +
                                                    "(" +
                                                    sub.count +
                                                    ")"
                                                  : sub}
                                              </span>
                                            </MenuItem>
                                          )
                                        )}
                                    </Select>
                                  </FormControl>
                                ) : (
                                  <FormControl fullWidth variant="outlined">
                                    <InputLabel
                                      htmlFor="suburb"
                                      className="mb-3"
                                    >
                                      Suburb
                                    </InputLabel>
                                    <OutlinedInput
                                      id="suburb"
                                      value=""
                                      readOnly // Prevents editing
                                      onFocus={handleFocus}
                                      onBlur={handleBlur}
                                      endAdornment={
                                        <InputAdornment position="end">
                                          {isFocused ? (
                                            <ArrowDropUpIcon />
                                          ) : (
                                            <ArrowDropDownIcon />
                                          )}
                                        </InputAdornment>
                                      }
                                      labelWidth={60} // Ensures proper label alignment
                                      style={{ cursor: "pointer" }} // Adds a pointer cursor to indicate interaction
                                    />
                                    {!props.suburb && isFocused ? (
                                      <FormHelperText error>
                                        Please enter a Post Code to see
                                        available suburbs.
                                      </FormHelperText>
                                    ) : (
                                      ""
                                    )}
                                  </FormControl>
                                )}
                              </div>
                            </div>

                            <div className="col-md-12 mt-4">
                              <InputLabel className="mb-2">Address</InputLabel>
                              <TextField
                                variant="outlined"
                                name="address"
                                value={props.callerDetails.address}
                                onChange={props.handleChange}
                                className={classes.textField}
                                onFocus={props.handleCallerFocus}
                                helperText={
                                  !props.callerDetails.address
                                    ? "Please enter the Address"
                                    : ""
                                }
                                fullWidth
                              />
                            </div>
                          </>
                        )}

                      {(props.callerDetails.firstName ||
                        props.callerDetails.lastName) &&
                        (props.callerDetails.phoneNumber1 ||
                          props.callerDetails.phoneNumber2) &&
                        props.postCode &&
                        (typeof props.suburb === "object"
                          ? props.suburb && props.suburb.suburbName
                          : props.suburb) &&
                        props.callerDetails.address && (
                          <div className="col-md-12 mt-4">
                            <InputLabel className="mb-2">Message</InputLabel>
                            <TextField
                              multiline
                              rows={4}
                              variant="outlined"
                              name="message"
                              value={props.callerDetails.message}
                              className={classes.textField}
                              onChange={props.handleChange}
                              onFocus={props.handleCallerFocus}
                            />
                          </div>
                        )}
                    </>
                  )}
                  <div className="col-md-12 mt-3">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={props.handleBack}
                        >
                          Back
                        </Button>
                        {props.suspendedFranchisee.leadSuspend === "0" && (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            className="ml-3"
                            disabled={
                              !(
                                (props.callerDetails.firstName ||
                                  props.callerDetails.lastName) &&
                                (props.callerDetails.phoneNumber1 ||
                                  props.callerDetails.phoneNumber2) &&
                                props.postCode &&
                                props.suburb &&
                                props.callerDetails.address &&
                                props.callerDetails.message
                              )
                            }
                          >
                            Next
                          </Button>
                        )}
                      </div>
                      <EndCallCard
                        handleEndCall={() =>
                          props.handleEndCall(props.callerDetails)
                        }
                      />
                    </div>
                    {props.showResetButton && (
                      <Button
                        variant="contained"
                        className="ml-3"
                        color="default"
                        onClick={props.handleReset}
                      >
                        Reset
                      </Button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          ) : (
            <ThankYouReference
              referenceNumber={props.callRefNumber}
              handleReset={props.handleReset}
            />
          )}
        </div>
      </div>
    </ResponsiveContainer>
  );
}

export default ContinueCancelBooking;
